import {Box, Typography} from '@mui/material';
import React from 'react';
import AurProfilePicture from '../../common/aur-profile-picture/AurProfilePicture';
import {t} from 'i18next';
import {AurLightTooltip} from '../../common/aur-light-tooltip/aur-light-tooltip';
import AurManageClientDropdown from '../../common/aur-manage-client-dropdown/AurManageClientDropdown';

interface AurClientDetailsViewProps {
  clientName: string;
  clientCode: string;
  clientId: string;
  displayText: string;
  createdBy: string;
  createdOn: string;
  onUpdateDrawerParent?: () => void;
}

const AurClientDetailsView: React.FC<AurClientDetailsViewProps> = (
  props: AurClientDetailsViewProps
) => {
  const {
    clientName,
    clientCode,
    clientId,
    displayText,
    createdOn,
    onUpdateDrawerParent,
  } = props;

  return (
    <Box>
      <div className="client-profile-main-container">
        <div className="client-profile-picture-container">
          <AurProfilePicture
            displayText={displayText}
            iconSize={92}
            textSize="Large"
            borderRadius={1}
            iconType="Client"
            backgroundImage={true}
          />
        </div>
        <div className="client-profile-details-container">
          <div className="client-profile-sub-container">
            <div>
              <Typography
                className={`typo-text display2_size grey-color-100`}
                tabIndex={0}
                component="h1"
              >
                {clientName}
              </Typography>
            </div>
            <div className="client-profile-right">
              <AurManageClientDropdown
                clientId={clientId}
                onUpdateDrawerParent={onUpdateDrawerParent}
              />
            </div>
          </div>
          <div className="client-profile-sub-container mist-color-700">
            <Typography className={`typo-text body1_size`} tabIndex={0}>
              {t('clientDetailsPage.clientId')}: {clientCode}
            </Typography>
            <div className="client-profile-right">
              <AurLightTooltip title={t('common.yearMonthDate')}>
                <Typography className={`typo-text label1_size`} tabIndex={0}>
                  {t('clientDetailsPage.projectDrawer.creatdOn')}
                  <span>{createdOn}</span>
                </Typography>
              </AurLightTooltip>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default AurClientDetailsView;
